/*
 * Copyright © 2026 MS IMAGES. All rights reserved.
 * Proprietary and confidential — unauthorized copying, distribution, or use
 * of this file, via any medium, is strictly prohibited. See LICENSE.
 */

/**
 * ============================================================================
 * Invoice Settings Service - API calls for invoice configuration
 * ============================================================================
 */

import { get, post, put, del } from '@/services/api/client';
import { ApiResponse } from '@/services/api/types';
import { InvoiceSettings, UpdateInvoiceSettingsRequest } from '@/types/superadmin.types';
import apiClient from '@/services/api/client';

const BASE_URL = '/superadmin/invoice-settings';

/**
 * Invoice settings service
 */
export const invoiceSettingsService = {
  /**
   * Get current invoice settings
   */
  async getSettings(): Promise<InvoiceSettings> {
    const response = await get<ApiResponse<InvoiceSettings>>(BASE_URL);
    return response.data;
  },

  /**
   * Update invoice settings
   */
  async updateSettings(request: UpdateInvoiceSettingsRequest): Promise<InvoiceSettings> {
    const response = await put<ApiResponse<InvoiceSettings>>(BASE_URL, request);
    return response.data;
  },

  /**
   * Upload signature image
   */
  async uploadSignatureImage(file: File): Promise<InvoiceSettings> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await apiClient.post<ApiResponse<InvoiceSettings>>(
      `${BASE_URL}/signature/upload`,
      formData
    );

    return response.data.data;
  },

  /**
   * Delete signature image
   */
  async deleteSignatureImage(): Promise<InvoiceSettings> {
    const response = await del<ApiResponse<InvoiceSettings>>(`${BASE_URL}/signature`);
    return response.data;
  },
};

export default invoiceSettingsService;
